import { createMasterApiClient } from '../../common/masterApiFactory';

export const relationApi = createMasterApiClient('relation');
